import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
} from "@angular/core";
import { ILinkTyped } from "src/app/shared/interface/link";
import { IUProperty } from "src/app/shared/interface/umbraco-property";

export interface IPricesTableLicenseItem {
  backgroundColor: IUProperty<string>;
  licenseName: IUProperty<string>;
  licenseNameColor: IUProperty<string>;
  link: IUProperty<ILinkTyped>;
  linkColor: IUProperty<string>;
  pricePerMonth: IUProperty<number>;
  pricePerYear: IUProperty<number>;
}

@Component({
  selector: "app-prices-table-license-item",
  templateUrl: "./prices-table-license-item.component.html",
  styleUrls: ["./prices-table-license-item.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PricesTableLicenseItemComponent implements AfterViewInit {
  @Input() item: IPricesTableLicenseItem;
  @Input() isLast: boolean;
  @Input() isFirst: boolean;

  constructor(private hostRef: ElementRef) {}

  ngAfterViewInit(): void {
    this.setCustomThemeProperties(this.item);
  }

  private setCustomThemeProperties(d: IPricesTableLicenseItem) {
    if (d.backgroundColor && d.backgroundColor.value) {
      this.hostRef.nativeElement.style.setProperty(
        "--license-item-body-color",
        d.backgroundColor.value
      );
    }

    if (d.licenseNameColor && d.licenseNameColor.value) {
      this.hostRef.nativeElement.style.setProperty(
        "--license-item-name-color",
        d.licenseNameColor.value
      );
    }

    if (d.linkColor && d.linkColor.value) {
      this.hostRef.nativeElement.style.setProperty(
        "--license-item-link-color",
        d.linkColor.value
      );
    }
  }
}
